// *工作流节点审批人 取 属性值 的 目标对象
export enum EWorkflowStepHandlerFromTarget {
  Project = 0,  // 项目
  Audit = 10,  // 流程
  Schedule = 20,  // 过程调度
}

